import { RootState } from 'src/store/store';

export const selectTaxCertApplicationLoading = (state: RootState) =>
  state.taxCertificate?.applicationLoading;
export const selectTaxCertApplicationError = (state: RootState) =>
  state.taxCertificate?.applicationError;
export const selectTaxCertApplicationFinished = (state: RootState) =>
  state.taxCertificate?.applicationFinished;
export const selectTaxCertApplicationData = (state: RootState) =>
  state.taxCertificate?.applicationData;
export const selectTaxCertApplicationNumber = (state: RootState) =>
  state.taxCertificate?.applicationNumber;
